import {
  WAREHOUSE_FETCH_STARTED,
  WAREHOUSE_FETCH_SUCCEEDED,
  WAREHOUSE_FETCH_FAILED,
  WAREHOUSE_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  warehouse: {},
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case WAREHOUSE_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case WAREHOUSE_FETCH_SUCCEEDED:
      const { project = {} } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        warehouse: {
          ...action.payload,
          project: {
            ...project,
            value: project?.id,
            label: project?.title
          }
        }
      };
    case WAREHOUSE_FETCH_FAILED:
      return { ...state, status: statuses.failed, warehouse: {}, error: action.error };
    case WAREHOUSE_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
